import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LinkGen } from "../LinkGen";
import { useIsAuthenticated } from "./useIsAuthenticated";

interface AuthRoutesProps {
	auth: boolean;
}

export const AuthRoutes: FC<AuthRoutesProps> = (props) => {
	const isAuthenticated = useIsAuthenticated();

	if (props.auth && !isAuthenticated) {
		return <Navigate to={LinkGen.Login()} />;
	}

	if (!props.auth && isAuthenticated) {
		return <Navigate to={LinkGen.Dashboard()} />;
	}

	return <Outlet />;
};
